import { Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SimulationDao } from '@app/dao/simulation/simulation.dao';
import * as _ from 'lodash';
import { Subject, map } from 'rxjs';
import { EaSimulationPerFormBuilder } from './ea-simulation-per-form.builder';

@Component({
    selector: 'ea-simulation-per-form',
    templateUrl: './ea-simulation-per-form.component.html',
    styleUrls: ['./ea-simulation-per-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaSimulationPerFormComponent),
        },
    ],
    standalone: false
})
export class EaSimulationPerFormComponent
  extends EaSimulationPerFormBuilder
  implements OnInit, OnDestroy
{
  doneSubject: Subject<void> = new Subject<void>();
  alive = true;
  $packs;

  constructor(
    protected formConstructor: PrFormConstructor,
    protected simulationDao: SimulationDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.$packs = this.simulationDao.getProductReference('PER').pipe(
      map(products =>
        _(products)
          .orderBy(p => p.name.toLowerCase(), ['asc'])
          .value(),
      ),
    );
  }

  onSubmit() {
    this.derrors = true;

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.prFormService.loading();
    this.prFormService.loaded();
    this.doneSubject.next(this.extract());

    if (this.callback) this.callback(this.extract());
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
}
